import React, {ReactNode} from 'react';
import {Card, CardBody} from 'reactstrap';

interface IProps {
  children: ReactNode
  isLoading: boolean
  title: string
  actions?: ReactNode
  disableCardBackgroundColor?: boolean
  styles?:{}
  titleStyles?:{}
}
export const CardComponent = (props: IProps) => {
  const {title, isLoading, actions, styles, titleStyles} = props;

  return (
    <Card style={styles}>
      <CardBody>
        <div>
          <div className="card-title" style={titleStyles}>
            {title}
            </div>
            <div style={{display:'inline-block',  marginTop:'20px', fontSize:'1.8rem', marginLeft:'15px'}}>
            {isLoading &&
              <i id="loadingTable" className="fa fa-cog fa-spin" />
            }
          </div>
        </div>
        {props.children}
      </CardBody>
      {(!isLoading && actions) && // don't show actions when data is loading
        <div className="card-action" style={{background:'white'}}>
          {actions}
        </div>
      }
    </Card>
  );
};
